import { render, staticRenderFns } from "./SelectMarketing.vue?vue&type=template&id=4cb2a384&"
import script from "./SelectMarketing.vue?vue&type=script&lang=js&"
export * from "./SelectMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports